export enum EAuthorizedRepresentativeDecision {
  IN_PROGRESS = "IN_PROGRESS",
  APPROVED = "APPROVED",
  CHANGES_REQUESTED = "CHANGES_REQUESTED",
}
